import axios from "axios";
import type { ApiResponse } from "@safiri/shared";
import { API_BASE_URL } from "../config/env";
import type { TripData } from "../types/trip";

export type TripLookup =
  | { kind: "ok"; trip: TripData }
  | { kind: "notFound" }
  | { kind: "error" };

/** Public trip lookup by share token — `GET /tripShare/:token`. */
export async function fetchSharedTrip(token: string): Promise<TripLookup> {
  try {
    const response = await axios.get<ApiResponse<TripData>>(
      `${API_BASE_URL}/tripShare/${encodeURIComponent(token)}`,
      { timeout: 15000 }
    );
    return response.data?.data
      ? { kind: "ok", trip: response.data.data }
      : { kind: "notFound" };
  } catch (error) {
    if (axios.isAxiosError(error) && error.response?.status === 404) {
      return { kind: "notFound" };
    }
    return { kind: "error" };
  }
}

export interface SharedRoute {
  leg: "toPickup" | "toDestination" | "planned";
  points: { latitude: number; longitude: number }[];
}

/** The current leg's route, computed server-side — `GET /tripShare/:token/route`. */
export async function fetchSharedRoute(token: string): Promise<SharedRoute | null> {
  try {
    const response = await axios.get<ApiResponse<SharedRoute>>(
      `${API_BASE_URL}/tripShare/${encodeURIComponent(token)}/route`,
      { timeout: 15000 }
    );
    return response.data?.data ?? null;
  } catch {
    return null;
  }
}
